<template>
  <div
    class="aggregate-rating align-center"
    :aria-label="translate('aria_label_aggregated_rating')"
    :class="displayNone ? 'd-none' : 'd-flex'"
    itemscope=""
    :itemprop="includeProps ? 'aggregateRating' : null"
    :itemtype="includeProps ? 'https://schema.org/AggregateRating' : null"
  >
    <meta v-if="includeProps" itemprop="worstRating" content="1" />
    <meta v-if="includeProps" itemprop="bestRating" content="5" />
    <HeartContainer :rating="+ratingData.ratingsAverage" class="mr-2" />
    <span
      v-if="!compact"
      class="mr-1"
      :itemprop="includeProps ? 'ratingValue' : null"
      :content="includeProps ? ratingData.ratingsAverage : null"
      >{{ ratingTitle }}</span
    >
    <span
      :itemprop="includeProps ? 'reviewCount' : null"
      :content="includeProps ? ratingData.ratingsCount : null"
      >({{ ratingData.ratingsCount }})</span
    >
  </div>
</template>

<script>
import { defineAsyncComponent } from 'vue'
const HeartContainer = defineAsyncComponent(
  () => import('@/components/basic/atoms/HeartContainer.vue')
)

const MAX_HEART_RATING = 5
const MIN_RATING_COUNT = 5

export default {
  components: { HeartContainer },
  props: {
    ratingData: {
      type: Object,
      required: true
    },
    showDropdownIcon: {
      type: Boolean,
      default: true
    },
    compact: {
      type: Boolean,
      default: false
    },
    includeProps: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ratingTitle() {
      return (
        parseFloat(this.ratingData.ratingsAverage).toFixed(1) +
        ' ' +
        this.translate('pdp_heart_ratings_out_of_x_hearts', MAX_HEART_RATING)
      )
    },
    displayNone() {
      return this.ratingData.ratingsCount < MIN_RATING_COUNT
    }
  }
}
</script>

<style scoped>
.aggregate-rating {
  cursor: pointer;
  pointer-events: all;
  color: rgb(var(--v-theme-gray));

  span {
    font-size: var(--regular-font-size);
    line-height: 13px;
  }
}

.aggregate-rating:hover span {
  color: rgb(var(--v-theme-graphit));
  transition: color var(--transition-duration-l)
    var(--transition-timing-cb-vicampo);
}

.aggregate-rating:hover > .rounded-circle {
  background-color: rgb(var(--v-theme-clay));
  transition: all var(--transition-duration-l)
    var(--transition-timing-cb-vicampo);

  svg {
    stroke-width: 3px;
    stroke: white;
  }
}

.rounded-circle {
  width: 16px;
  height: 16px;

  svg {
    stroke-width: 1px;
    stroke: rgb(var(--v-theme-clay));
  }
}
</style>
